/* ================================================
   PERMISSION TO DISAPPOINT — Landing Page JS v15
   Manual carousels · No autoplay
   ================================================ */

document.addEventListener('DOMContentLoaded', function() {

  /* ================================================
     SMOOTH SCROLL FOR ANCHOR LINKS
     ================================================ */
  document.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var targetId = this.getAttribute('href');
      if (targetId === '#') return;
      var target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        var offset = target.getBoundingClientRect().top + window.pageYOffset - 20;
        window.scrollTo({ top: offset, behavior: 'smooth' });
      }
    });
  });

  /* ================================================
     GENERIC CAROUSEL (no autoplay, swipe + buttons)
     ================================================ */
  function initCarousel(carouselId, prevId, nextId, dotsId) {
    var carousel = document.getElementById(carouselId);
    if (!carousel) return;
    var track = carousel.querySelector('.ptd-carousel-track');
    var slides = carousel.querySelectorAll('.ptd-carousel-slide');
    var prev = document.getElementById(prevId);
    var next = document.getElementById(nextId);
    var dotsWrap = document.getElementById(dotsId);
    if (!track || !slides.length) return;

    var index = 0;
    var startX = 0;

    // Create dots
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var j = 0; j < slides.length; j++) {
        var dot = document.createElement('button');
        dot.className = 'ptd-carousel-dot' + (j === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'Slide ' + (j + 1));
        (function(x) { dot.addEventListener('click', function() { goTo(x); }); })(j);
        dotsWrap.appendChild(dot);
      }
    }

    function goTo(x) {
      index = x < 0 ? slides.length - 1 : x >= slides.length ? 0 : x;
      track.style.transform = 'translateX(-' + (index * slides[0].offsetWidth) + 'px)';
      if (dotsWrap) {
        var dots = dotsWrap.querySelectorAll('.ptd-carousel-dot');
        for (var k = 0; k < dots.length; k++) {
          dots[k].classList.toggle('active', k === index);
        }
      }
    }

    if (prev) prev.addEventListener('click', function() { goTo(index - 1); });
    if (next) next.addEventListener('click', function() { goTo(index + 1); });

    // Touch swipe
    carousel.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
    }, { passive: true });

    carousel.addEventListener('touchend', function(e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        goTo(diff > 0 ? index + 1 : index - 1);
      }
    }, { passive: true });

    // Resize
    window.addEventListener('resize', function() { goTo(index); });

    goTo(0);
  }

  // Scripts carousel
  initCarousel('previewCarousel', 'carouselPrev', 'carouselNext', 'carouselDots');

  // Workbook carousel
  initCarousel('workbookCarousel', 'workbookCarouselPrev', 'workbookCarouselNext', 'workbookCarouselDots');

  /* ================================================
     FAQ ACCORDION
     ================================================ */
  var faqItems = document.querySelectorAll('.ptd-faq-item');

  faqItems.forEach(function(item) {
    var summary = item.querySelector('summary');
    if (!summary) return;
    summary.addEventListener('click', function(e) {
      e.preventDefault();
      var isOpen = item.hasAttribute('open');
      faqItems.forEach(function(other) {
        if (other !== item && other.hasAttribute('open')) {
          other.removeAttribute('open');
        }
      });
      if (isOpen) {
        item.removeAttribute('open');
      } else {
        item.setAttribute('open', '');
      }
    });
  });

  /* ================================================
     STICKY CTA — show between hero and pricing
     ================================================ */
  var sticky = document.getElementById('ptdSticky');
  var hero = document.getElementById('ptd-hero');
  var pricing = document.getElementById('pricing');

  if (sticky && hero) {
    var ticking = false;

    function checkSticky() {
      var heroBottom = hero.getBoundingClientRect().bottom;
      var pricingTop = pricing ? pricing.getBoundingClientRect().top : Infinity;
      var wh = window.innerHeight;

      if (heroBottom < 0 && pricingTop > wh) {
        sticky.classList.add('visible');
      } else {
        sticky.classList.remove('visible');
      }
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          checkSticky();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    checkSticky();
  }

});
